import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const MasterCardMyCard = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="35"
        height="24"
        viewBox="0 0 35 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M21.4344 4.92426H13.5869V19.0759H21.4344V4.92426Z"
          fill="#FF5F00"
        />
        <path
          d="M14.0855 12C14.0842 10.6371 14.392 9.29178 14.9855 8.06588C15.5789 6.83999 16.4425 5.76565 17.5109 4.9242C16.1879 3.88061 14.5989 3.23162 12.9257 3.0514C11.2525 2.87118 9.56247 3.16701 8.04886 3.90507C6.53525 4.64313 5.2591 5.79366 4.36628 7.22513C3.47346 8.6566 3 10.3113 3 12C3 13.6887 3.47346 15.3434 4.36628 16.7749C5.2591 18.2063 6.53525 19.3569 8.04886 20.0949C9.56247 20.833 11.2525 21.1288 12.9257 20.9486C14.5989 20.7684 16.1879 20.1194 17.5109 19.0758C16.4426 18.2343 15.5789 17.16 14.9855 15.9341C14.392 14.7082 14.0842 13.3629 14.0855 12Z"
          fill="#EB001B"
        />
        <path
          d="M32.0217 12C32.0218 13.6887 31.5484 15.3434 30.6556 16.7748C29.7628 18.2063 28.4867 19.3568 26.9732 20.0949C25.4596 20.833 23.7696 21.1288 22.0964 20.9486C20.4232 20.7684 18.8342 20.1194 17.5112 19.0758C18.5787 18.2335 19.4416 17.159 20.035 15.9333C20.6284 14.7076 20.9367 13.3627 20.9367 12C20.9367 10.6373 20.6284 9.29241 20.035 8.06671C19.4416 6.84101 18.5787 5.7665 17.5112 4.9242C18.8342 3.88061 20.4232 3.23162 22.0964 3.0514C23.7696 2.87118 25.4596 3.16702 26.9732 3.90509C28.4867 4.64316 29.7628 5.79369 30.6556 7.22516C31.5484 8.65663 32.0218 10.3113 32.0217 12Z"
          fill="#F79E1B"
        />
      </svg>
    );
  }
);
export default MasterCardMyCard;
